import { http } from '@/utils/request'
import { IResultDefault } from './commonInterface'
const NODE_ENV = import.meta.env.VITE_APP_ENV

// 云平台老接口
const fromKf = 'apix.mj.com' ||  'apix.major.com' ||  'apix.majorbio.com' ||  'apix.sg.com' ||  'apix.sanger.com' ||  'apix.i-sanger.com'
// 科服网老接口
const fromApi = 'www.mj.com' || 'www.major.com' || 'www.majorbio.com' || 'www.sg.com' || 'www.sanger.com' || 'www.i-sanger.com'

// 提醒数量（我的事项、项目总览）
export function fetchNoticeCount(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromApi // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('api/web/ucenter/project/confirm/get-notice-count', params)
}

export function getProjectType(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('vip/contract/productEnum', params)
}

// 获取图形验证码
export function fetchCaptcha(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromApi // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('api/web/common/captcha/get-captcha', params)
}

// 获取 未确认的 VIP客户中心 推送的合同立项消息
export function fetchContractRead(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('vip/contract/unconfirmed', params)
}

// 原始数据确认弹框提醒
export function fetchPanMajorbioData(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('vip/releaseData/confirmCheck', params)
}

// 我的事项、线下报告、原始数据-待处理提醒数
export function fetchPendingCount(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('vip/notification/pending-count', params)
}

// 是否显示关注公众号弹窗
export function isShowSubscribe(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('kf/isShowSubscribe', params)
}

// 稍后再说
export function hideShowSubscribe(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('kf/hideShowSubscribe', params)
}

// 公告弹窗、导航栏消息
export function fetchHomeNoticeList(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('kf/noticeList', params)
}

// 我知道了
export function homeNoticeRead(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestPost('kf/noticeRead', params)
}

// 获取导航栏的一二级菜单
export function fetchAllMenu(params: any): Promise<IResultDefault> {
  params = {
    ...params,
    from:fromApi // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('api/web/common/nav/allMenu', params)
}

// 获取所有省信息
export function fetchProvinces(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('basic/location/area/provinces',params)
}

// 根据省id获取所有市信息
export function fetchCities(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('basic/location/area/cities', params)
}

// 根据市id获取所有区信息
export function fetchDistricts(params: any): Promise<IResultDefault> {
  return http.httpRequestGet('basic/location/area/districts', params)
}

// vip客户中心登录
export function vipLogin(params: any): Promise<IResultDefault> {
  return http.httpRequestPost('vip/login', params)
}


//上传资源临时token
export function getResourceToken(params: any) {
  return http.httpRequestPost('basic/resource/resource/token', params)
}

//上传资源创建
export function getResourceId(params: any) {
  return http.httpRequestPost('basic/resource/resource/store', params)
}

// 获取美吉、桑格网盘版本号等信息
export function getLastVersion(params: any): Promise<IResultDefault> {
  let diskApiUrl = NODE_ENV === 'production' ? 'https://data-release-api.i-sanger.cn' : 'http://data-release-api.tngs.com';
  return http.httpRequestGet(`${diskApiUrl}/version/last?device_type=1`, params)
}

// 切换角色
export function changeRole(params: any): Promise<IResultDefault> {
  params = {
    ...params,  
    from:fromKf // 临时的参数，后面可能会删除，用于区分baseURL
  }
  return http.httpRequestGet('user/change_ypt_type', params)
}